import { DirectionalDroppableType, Widget } from '@framework/engine';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { sortingStrategyDirection } from '../utils/sortingStrategyDirection';

const InsertPositionIndicatorDiv = styled.div`
  position: absolute;
  z-index: 9;
  width: 50%;
  background-color: transparent;

  // indicatore per inserisci elemeto sopra
  // Widget posizionati in colonna (comportamento di default)
  height: 0px;
  border-radius: 2px;
  transition: all 0.25s ease-in-out;
  &.show-indicator:not(.horizontal) {
    background-color: ${props => props.theme.colorPrimary};
    border-radius: 3px;
    height: 6px;
    width: 100%;
  }
  // indicatore per inserisci elemeto a sinistra
  // Widget posizionati in Container Row
  &.horizontal {
    height: 50%;
    width: 0px;
    &.show-indicator {
      background-color: ${props => props.theme.colorPrimary};
      border-radius: 3px;
      height: 100%;
      width: 6px;
    }
  }
  // Versione indicatore per container
  &&& {
    &.insert-post {
      bottom: -9px;
      &.horizontal {
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
    &.insert-pre {
      top: -15px;
      &.horizontal {
        left: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
`;

export interface InsertPositionIndicatorProps {
  showIndicator?: boolean;
  parent?: Widget;
  type?: DirectionalDroppableType;
}

function getSideClass(type: DirectionalDroppableType | null | undefined) {
  if (!type) return undefined;
  return type === DirectionalDroppableType.Before
    ? 'insert-pre'
    : 'insert-post';
}

/**
 * Indicatore di posizione per l'inserimento di un widget nel DnD
 */
export function InsertPositionIndicator(props: InsertPositionIndicatorProps) {
  const { showIndicator, parent, type } = props;
  const sideClass = getSideClass(type);

  return (
    <InsertPositionIndicatorDiv
      className={clx(`${sortingStrategyDirection(parent)}`, sideClass, {
        'show-indicator': showIndicator,
      })}
    />
  );
}
